import { useEffect, useRef } from 'react';

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('analytics_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
    sessionStorage.setItem('analytics_session_id', sessionId);
  }
  return sessionId;
};

// Track a page view
export const trackPageView = async (page, trainingId = null) => {
  try {
    const data = {
      page: page || window.location.pathname,
      referrer: document.referrer || null,
      session_id: getSessionId(),
      user_agent: navigator.userAgent,
      screen_width: window.innerWidth,
      screen_height: window.innerHeight,
      training_id: trainingId
    };
    
    await fetch(`${API}/track/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
  } catch (error) {
    // Silently fail - analytics should not break the app
    console.debug('Analytics tracking failed:', error);
  }
};

// Hook to automatically track page views
export const usePageTracking = (trainingId = null) => {
  const tracked = useRef(false);
  
  useEffect(() => {
    if (!tracked.current) {
      trackPageView(window.location.pathname, trainingId);
      tracked.current = true;
    }
  }, [trainingId]);
};

export default usePageTracking;
